module.exports = __webpack_public_path__ + "img/p12.7a0f62fb.png";